<template>
	<div class="Airep-box">
		<div class="title">拜耳影像学苑-在线学术沟通平台</div>
		<p>三位一体，为您提供全方位学术支持通道：</p>
		<p>“拜耳影像学苑”微信公众号</p>
		<p>1. 学术资料，包罗万象</p>
		<p>2. 学术会议，尽收眼底</p>
		<p>3. 医学工具，助力临床</p>
		<p>“拜耳影像学苑”学习型微信社群</p>
		<p>1. 创新社群，学无止境</p>
		<p>2. 高效互动，事半功倍</p>
		<p>3. 因需制宜，形式丰富</p>
		<p>“拜耳影像学苑”学术助手</p>
		<p>1. 专属私助，及时响应</p>
		<p>2. 定期互动，知您所需</p>
		<p>3. 活动定制，精益求精</p>
		<div class="footer_message">
			如果您希望得到以上学术服务，请留下您的手机号并签署
			<span @click="$router.push({ path: '/agreementDoctor' })"
				>《个人信息披露知情同意》</span
			>
			，我们的学术助手会尽快联系你。
		</div>
		<div class="input_mobile">
			<van-cell-group>
				<van-field
					class="name"
					v-model="mobile"
					placeholder="请输入您的手机号"
				/>
			</van-cell-group>
		</div>
		<div class="forrter_btn">
			<!-- <div @click="save(false)">不同意</div>
			<div @click="save(true)">同意</div> -->
			<div @click="save(false)">不同意</div>
			<div @click="save(true)">同意</div>
		</div>
	</div>
</template>

<script>
export default {
	
  	created() {
		this.redirectTo()
	},
	data() {
		return {
			show: true,
			mobile: localStorage.getItem('mobile'),
		}
	},
	methods: {    
		redirectTo(){
      		window.location.href = "https://newradacademy.wechat.bayer.cn/bayer-rad-academy-shadowcloud-academy-html/register";
    	},
		save(type) {
			if (type) {
				localStorage.setItem('mobile', this.mobile)
				if (this.$route.params.type) {
					this.$router.push({ path: '/user/info/' + this.mobile })
				} else {
					this.$router.back()
				}
			} else {
				this.mobile = ''
				localStorage.setItem('mobile', null)
				if (this.$route.params.type) {
					this.$router.push({ path: '/user/info' })
				} else {
					this.$router.back()
				}
			}
		},
	},
}
</script>

<style lang="scss" scope>
.forrter_btn {
	display: flex;
	margin-top: 40px;
	div {
		text-align: center;
		font-size: 30px;
		font-weight: 600;
		border-radius: 40px;
		line-height: 80px;
		&:nth-child(1) {
			color: #333333;
			width: 290px;
			background: #eaeaea;
			margin-right: 20px;
		}
		&:nth-child(2) {
			background: #0090c5;
			color: #ffffff;
			width: 290px;
		}
	}
}
.input_mobile {
	margin-top: 40px;
	border-radius: 40px;
	overflow: hidden;
}
.footer_message {
	font-size: 28px;
	line-height: 42px;
	font-weight: 400;
	margin-top: 40px;
	span {
		color: #0090c5;
	}
}
.Airep-box {
	.title {
		margin-top: 50px;
		margin-bottom: 20px;
		text-align: center;
		font-weight: 600;
		font-size: 34px;
		color: #333;
	}
	min-height: 100%;
	background: #f5f5f5;
	box-sizing: border-box;
	padding: 0 70px;
	font-size: 28px;
	line-height: 42px;
	font-weight: 400;
	text-align: left;
	p {
		&:nth-child(2) {
			margin-top: 20px;
			margin-bottom: 40px;
		}
		&:nth-child(7) {
			margin-top: 40px;
		}
		&:nth-child(11) {
			margin-top: 40px;
		}
		&:nth-child(15) {
			margin-top: 40px;
		}
	}
}
</style>
